import { container } from './container';
import { appModules } from './app.module';

let initialized = false;

/**
 * Costura a aplicação: percorre os módulos listados em `app.module.ts` e
 * roda a fiação de DI de cada um no container central — o equivalente ao
 * `imports: [...]` do `AppModule` do NestJS.
 *
 * Idempotente: chamar mais de uma vez não re-registra.
 */
export function initModules(): void {
  if (initialized) return;
  for (const module of appModules) {
    module.register?.(container);
  }
  initialized = true;
}
